import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { FlightReshopService } from '../flight-reshop.service';
import {
  loadSliceBySliceReshopResults,
  loadSliceBySliceReshopResultsComplete,
  setSessionId,
  setSolutionSetId,
} from './flight-reshop-service.actions';
import { Store } from '@ngrx/store';
import { RootState } from '../../../state/state';
import { GlobalEvent, GlobalEventService } from '../../global-event-service/global-event.service';
import { VoluntaryChangeStore } from '../../../features/voluntary-change/stores/voluntary-change.store';

@Injectable()
export class FlightReshopServiceEffects {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly actions$ = inject(Actions);
  private readonly service = inject(FlightReshopService);
  private readonly globalEventService = inject(GlobalEventService);
  private readonly voluntaryChangeStore = inject(VoluntaryChangeStore);

  loadSliceBySliceReshopResults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSliceBySliceReshopResults),
      mergeMap((action) => {
        const request = this.voluntaryChangeStore.sliceBySliceSearchRequest();
        return this.handleSliceBySliceReshop(request);
      })
    )
  );

  private handleSliceBySliceReshop(request: any) {
    this.globalEventService.broadcastAjax(GlobalEvent.AJAX_START);
    return this.service.getSliceBySliceResults(request).pipe(
      map((result) => {
        this.globalEventService.broadcastAjax(GlobalEvent.AJAX_END);

        // If result has error information, pass it as an object
        if (result.error || result.errorStatus) {
          const errorObject: { error?: string; errorStatus?: number } = {};
          if (result.error !== undefined) {
            errorObject.error = result.error;
          }
          if (result.errorStatus !== undefined) {
            errorObject.errorStatus = result.errorStatus;
          }
          return loadSliceBySliceReshopResultsComplete(result.response, errorObject);
        }

        this.store.dispatch(setSessionId(result.response?.sessionId || null));
        this.store.dispatch(setSolutionSetId(result.response?.solutionSetId || null));
        return loadSliceBySliceReshopResultsComplete(result.response, null);
      }),
      catchError((err) => {
        this.globalEventService.broadcastAjax(GlobalEvent.AJAX_END);
        return of(loadSliceBySliceReshopResultsComplete(null, err.error?.toString()));
      })
    );
  }
}
